/* =========================================================================
   MARKETING Hero — Ads Doctor: shared types, presets, and diagnostic order.
   ========================================================================= */

/** Problem presets from the spec (what the user is worried about). */
export const ADS_PRESETS: { id: string; label: string }[] = [
  { id: "auto", label: "ให้ AI วิเคราะห์เอง (จากตัวเลข)" },
  { id: "no_lead", label: "ไม่มี Lead" },
  { id: "low_message", label: "ทักแชตน้อย" },
  { id: "high_cpl", label: "CPL แพง" },
  { id: "high_cpm", label: "CPM สูง" },
  { id: "low_ctr", label: "CTR ต่ำ" },
  { id: "high_cpc", label: "CPC แพง" },
  { id: "high_frequency", label: "Frequency สูง" },
  { id: "low_conversion", label: "Conversion ต่ำ" },
  { id: "poor_lead_quality", label: "Lead คุณภาพต่ำ" },
  { id: "lead_no_response", label: "Lead ไม่ตอบกลับ" },
  { id: "lead_no_sale", label: "มี Lead แต่ปิดการขายไม่ได้" },
  { id: "low_roas", label: "ROAS ต่ำ" },
  { id: "creative_fatigue", label: "Creative ล้า (Fatigue)" },
  { id: "scaling_failed", label: "Scale แล้วพัง" },
  { id: "not_spending", label: "แอดไม่ใช้เงิน" },
  { id: "performance_dropped", label: "ผลตกลงกะทันหัน" },
];

/** The mandatory diagnostic order — Ads Doctor checks top-down. */
export const CHECK_ORDER = [
  "Business Objective", "Data Sufficiency", "Time Range", "Budget", "CPM", "CTR", "CPC",
  "Conversion Rate", "Lead Quality", "Creative", "Hook", "Offer", "Audience", "Interest",
  "Frequency", "Landing Page", "Message Match", "Follow-up", "Sales Process", "Revenue", "ROAS",
];

export interface AdsMetrics {
  platform?: string;
  objective?: string;
  timeRange?: string; // e.g. "7 วัน"
  dailyBudget?: number | null;
  spend?: number | null;
  impression?: number | null;
  reach?: number | null;
  click?: number | null;
  ctr?: number | null; // %
  cpc?: number | null;
  cpm?: number | null;
  frequency?: number | null;
  lead?: number | null;
  message?: number | null;
  cpl?: number | null;
  conversion?: number | null;
  sale?: number | null;
  revenue?: number | null;
  roas?: number | null;
  leadQuality?: string; // ดี | กลาง | แย่
}

export interface AdsContext {
  creative?: string;
  hook?: string;
  offer?: string;
  audience?: string;
  landingPage?: string;
  followUp?: string;
}

export interface DiagnosisAction { action: string; why: string; }
export interface MetricRead { metric: string; value: string; read: string; tone: "ok" | "warn" | "bad" | "neutral"; }

export interface AdsDiagnosisOutput {
  objectiveNote: string;
  dataSufficiency: { enough: boolean; note: string };
  mainDiagnosis: string;
  secondaryDiagnosis?: string;
  evidence: string[];
  confidence: "high" | "medium" | "low";
  severity: "low" | "medium" | "high";
  priority: number;
  metricReview: MetricRead[];
  recommendedAction: DiagnosisAction[];
  doNotChangeYet: string;
  testPlan: string;
  expectedSignal: string;
  whenToReview: string;
  alternativeExplanation: string;
  disclaimer?: string;
}

export const ADS_DIAGNOSIS_SCHEMA_HINT = {
  objectiveNote: "string",
  dataSufficiency: { enough: true, note: "string" },
  mainDiagnosis: "string",
  secondaryDiagnosis: "string",
  evidence: ["string"],
  confidence: "high|medium|low",
  severity: "low|medium|high",
  priority: 1,
  metricReview: [{ metric: "string", value: "string", read: "string", tone: "ok|warn|bad|neutral" }],
  recommendedAction: [{ action: "string", why: "string" }],
  doNotChangeYet: "string — สิ่งที่ยังไม่ควรเปลี่ยน",
  testPlan: "string",
  expectedSignal: "string",
  whenToReview: "string",
  alternativeExplanation: "string",
};
